module.exports = __webpack_public_path__ + "media/images/arrow-w-3c84af38e635a8721e49acb9ad73ba14.png";